import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import ImageLoader from '../image-loader';
import VideoEmbed from '../video-embed';
import styles from './text-editor-video-embed.scss';

class TextEditorVideoEmbed extends Component {
  renderLoader = isLoading => isLoading && <ImageLoader className={styles.loader}/>;

  renderVideoPlayer = oembed =>
    oembed && <VideoEmbed oembed={oembed} isPlayDisabled={!this.props.blockProps.readOnly}/>;

  render = () => {
    const { block, contentState, className } = this.props;
    const entity = contentState.getEntity(block.getEntityAt(0));
    const { oembed, isLoading } = entity.getData();

    const containerClassName = classNames(styles.container, className, 'text-editor-video-embed', {
      [styles.isLoading]: isLoading,
    });

    return (
      <div {...getElementProps(this.props)} className={containerClassName} draggable>
        {this.renderLoader(isLoading)}
        {this.renderVideoPlayer(oembed)}
      </div>
    );
  };
}

function getElementProps(props) {
  return _.omit(props, [
    'block',
    'blockProps',
    'contentState',
    'customStyleMap',
    'customStyleFn',
    'decorator',
    'forceSelection',
    'offsetKey',
    'tree',
    'theme',
    'direction',
    'selection',
    'readOnly',
  ]);
}

TextEditorVideoEmbed.propTypes = {
  block: PropTypes.object.isRequired,
  blockProps: PropTypes.object.isRequired,
  contentState: PropTypes.object,
  className: PropTypes.string,
};

export default TextEditorVideoEmbed;



// WEBPACK FOOTER //
// ./app/components/text-editor/text-editor-video-embed.js